module.exports = __webpack_public_path__ + "img/logo.5591e9e9.png";